var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"slide"},[(_vm.data.subtitle)?_c('span',{staticClass:"slide__block-heading"},[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_c('span',{staticClass:"slide__block-tool"},[_vm._v(_vm._s(_vm.data.subtitle || _vm.data.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }